import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  //list
  p: number = 1;
  itemsPerPage: number = 10;
  userRecord!: any[];
  seachText: any;
  userRecordData: any[] | undefined;
  states!: any[];
  selectedState!: any;

  StateRecord: any[] | undefined;
  [x: string]: any;

  addUserForm!: FormGroup;
  submitted = false;
  success = false;
  isReadMode = true;
  role:any;
  roles_data!: any;

  constructor(private formBuilder: FormBuilder, private router: Router,private toastr: ToastrService, private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService
    // , private alertService: AlertService
  ) { }

  ngOnInit() {
    this.role = this.authService.getRole();
    this.addUserForm = this.formBuilder.group({
      stateCode: ['', Validators.required],
      userId: [''],
      userName: [''],
      roles: [''],
      designation: [''],
      emailId: ['', Validators.required],
      mobileNo: ['', Validators.required],
      password:['']
      // mobileNo: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]]

    })

    //list
    this.bindState();
    this.getUserData();
    
  }
  getUserData()
  {
    this.spinnerService.show();
    this.fswService.getUsersDetail().subscribe((data: any[]) => {
      console.log(data);
      this.userRecord = data;
      this.userRecordData = data;
      this.spinnerService.hide();
    })
  }
  bindState(): void {
    this.fswService.getState().subscribe((data: any[]) => {
      console.log(data);
      this.states = data;
      this.StateRecord = data;
    })

  }
  search() {
    debugger
    this.p=1;
    console.log(this.seachText);
    this.userRecordData = this.userRecord;
    if (this.seachText != undefined && this.seachText!='') {
        if(this.selectedState!=undefined && this.selectedState!='')
        {
          let obj = this.userRecord.filter(m => ((  m.userName.indexOf(this.seachText)>-1))&& m.stateCode==this.selectedState);
          this.userRecordData = obj;
        }
        else
        {
          let obj = this.userRecord.filter(m => (m.userName.indexOf(this.seachText) >-1));
          this.userRecordData = obj;
        }
     
    }
    else{


        if(this.selectedState != undefined && this.selectedState!="")
        {
            let obj = this.userRecord.filter(m => (m.stateCode == this.selectedState));
            this.userRecordData = obj;  
        }
        else
        {
           this.toastr.error("Please provide at least one search value");  
        }

    }
    console.log(this.userRecordData);
    return this.userRecordData;
  }

  updateRow(x: any) {
    console.log(x);
    debugger
    var delBtn = confirm(" Do you want to update ?");
    if (delBtn == true) {
      debugger
      this.spinnerService.show();
      this.isReadMode = false;
      this.bindState();
      this.id = x.id;
      if(x.roleName == "SO")
      {
        x.roleName = "ROLE_SO";
      }
      else if(x.roleName == "RO")
      {
        x.roleName = "ROLE_RO";
      }
      this.selectedState = x.stateCode;
      this.addUserForm.controls['userId'].setValue(x.userId);
      this.addUserForm.controls['userName'].setValue(x.userName);
      this.addUserForm.controls['stateCode'].setValue(x.stateCode);
      this.addUserForm.controls['roles'].setValue(x.roleName);
      this.addUserForm.controls['emailId'].setValue(x.emailId);
      this.addUserForm.controls['mobileNo'].setValue(x.mobileNo);
      this.addUserForm.controls['designation'].setValue(x.designation);
      this.addUserForm.controls['password'].setValue(x.password);
      this.spinnerService.hide();
      }
  }
  deleteNodelOfficer(nodelOfficer)
  {
    this.spinnerService.show();
    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {
      console.log(nodelOfficer);
      this.fswService.deleteNodelOfficer(nodelOfficer.id)
      .subscribe(
        response => {
          this.p=1;
         
          this.spinnerService.hide();
          this.toastr.success("Nodel Officer deleted successfully");  
          this.getUserData();
         
         
        },
        error => {
          console.log(error);
          this.spinnerService.hide();
          
        });

    }
  }
  onupdateUserSubmit() {
    this.spinnerService.show();
    this.submitted = true;
    debugger
    if (this.addUserForm.invalid) {
      return;
    }
    var role = ["ROLE_SO"]
    this.addUserForm.controls['roles'].setValue(role);
    console.log(this.addUserForm.value);
    this.fswService.updateProfileData(this.id, this.addUserForm.value)
      .subscribe(
        response => {
          this.submitted = true;
          this.spinnerService.hide();
          this.isReadMode = true;
          this.bindState();
          this.getUserData();
          this.seachText = null;
        },
        error => {
          console.log(error);
          this.spinnerService.hide();
          
        });

    this.success = true;
    this.addUserForm.reset({});
  }
  closeAlert() {
    this.success = false;
  }
  reset() {
    debugger
    // window.location.reload();
    this.selectedState = "";
    this.seachText = "";
    this.fromDate="";
    this.endDate="";
    this.ngOnInit();
  }
}
